import { render, staticRenderFns } from "./WeeklyOrMonthly.vue?vue&type=template&id=0b536272&scoped=true&"
import script from "./WeeklyOrMonthly.vue?vue&type=script&lang=js&"
export * from "./WeeklyOrMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b536272",
  null
  
)

export default component.exports